module.exports = __webpack_public_path__ + "img/Gif_web2.94f50d00.gif";